import React from 'react';
import './StandardRatesComponent.css';

const StandardRatesComponent = () => {
    const bundleData = {
        "1_DAY_DATA_BUNDLE": [
            { data: "50MB", price: "R1" },
            { data: "100MB", price: "R2" },
            { data: "500MB", price: "R9" },
            { data: "1.5GB", price: "R19" }
        ],
        "7_DAY_DATA_BUNDLE": [
            { data: "250MB", price: "R5" },
            { data: "500MB", price: "R15" },
            { data: "1GB", price: "R19" },
            { data: "2GB", price: "R25" }
        ],
        "30_DAY_DATA_BUNDLE": [
            { data: "1GB", price: "R29" },
            { data: "2GB", price: "R49" },
            { data: "5GB", price: "R89" },
            { data: "10GB", price: "R149" }
        ],
        "180_DAY_DATA_BUNDLE": [
            { data: "20GB", price: "R299" },
            { data: "40GB", price: "R499" },
            { data: "100GB", price: "R899" },
            { data: "200GB", price: "R1699" }
        ]
    };

    const formatBundleTitle = (title) => {
        return title.replace(/_/g, ' ').toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <div className="standard-rates-container">
            <div className="standard-rates-card">
                <h2 className="standard-rates-title">STANDARD RATES</h2>
      <p style={{paddingBottom: "20px", textAlign: "center"}}>     <strong>k'nect bundles are available at all tills in-store, via USSD *135# or on Money Market Account.</strong>
      </p>
                <div className="bundle-grid">
                    {Object.entries(bundleData).map(([bundleType, bundles], index) => (
                        <div key={bundleType} className="bundle-section">
                            <div className="bundle-title">
                                {formatBundleTitle(bundleType)}
                            </div>
                            
                            <div className="bundle-list">
                                {bundles.map((bundle, bundleIndex) => (
                                    <div key={bundleIndex} className="bundle-row">
                                        <span className="bundle-data">{bundle.data}</span>
                                        <span className="bundle-price">{bundle.price}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StandardRatesComponent;